<script setup>
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(["update:modelValue"])

// Mismos labels EXACTOS del panel de filtros del proveedor de hoteles
// (ver hoteles.js / activar_filtro en el backend): roomFacilityFilter-VIEW
// y accommodationFacilityFilter-STAY_TYPE.
const opciones = [
  "Vistas al mar",
  "Solo para adultos",
  "Admite mascotas",
  "Ideal para familias"
]

function estaActivo(opcion) {
  return props.modelValue.includes(opcion)
}

function toggle(opcion) {
  const actual = props.modelValue

  const nuevo = estaActivo(opcion)
    ? actual.filter(o => o !== opcion)
    : [...actual, opcion]

  emit("update:modelValue", nuevo)
}
</script>

<template>

  <div class="col-12 mt-3">

    <label class="form-label fw-bold mb-2">
      <i class="bi bi-sliders"></i>
      Filtros opcionales de hotel
    </label>

    <div class="row g-2">

      <div
        v-for="opcion in opciones"
        :key="opcion"
        class="col-6 col-md-3 form-check form-switch"
      >

        <input
          class="form-check-input"
          type="checkbox"
          :id="`filtro-opcional-${opcion}`"
          :checked="estaActivo(opcion)"
          @change="toggle(opcion)"
        >

        <label
          class="form-check-label"
          :for="`filtro-opcional-${opcion}`"
        >
          {{ opcion }}
        </label>

      </div>

    </div>

  </div>

</template>
